// import chineseTranslator from 'chinese-utils'
import chineseTranslator from './_chineseTranslator'
import store from '../store'

import 'es6-promise/auto'
import 'array-flat-polyfill'

const TimSort = require('timsort')

const CountCompare = function (a, b) {
  return b.count - a.count
}

const fieldsMapping = store.state.collections.setting.fieldsMapping
const sources = store.state.collections.setting.sources

const getFq = function (vm, sourceKey) {
  let fieldsMap = fieldsMapping[sourceKey]
  return Object.keys(vm.selectedFacets).map(function (key) {
    if (vm.selectedFacets[key].length > 0) {
      // console.log(key, vm.selectedFacets[key])
      // console.log('{!terms f=' + fieldsMap[key] + ' separator="，"}' + vm.selectedFacets[key].join('，'))
      return '{!terms f=' + fieldsMap[key] + ' separator="，"}' + vm.selectedFacets[key].map(x => x.facet).join('，')
      // return vm.selectedFacets[key].map(x => `${fieldsMap[key]}:"${x.facet}"`)
    } else {
      return []
    }
  }).filter(function (array) {
    return array.length > 0
  }).flat()
}

const getQ = function (vm, sourceKey) {
  const fieldsMap = fieldsMapping[sourceKey]
  // console.log(fieldsMap)
  const textFields = fieldsMap.text.split('|')
  const terms = vm.terms.map(function (term) {
    // console.log(term, chineseTranslator.expandTerms2(term))
    return chineseTranslator.expandTerms2(term)
  })
  const userQuery =
  (vm.terms.length > 0 ? '(' + textFields.map(textField => {
    return '(' + terms.map(function (term) {
      const NOT = term[0].startsWith('"-') ? '-' : ''
      return NOT + '(' + term.map(function (t) {
        return [textField, (t.startsWith('"-') ? '"' + t.substring(2) : t)].join(':')
      }).join(' OR ') + ')'
    }).join(' AND ') + ')'
  }).join(' OR ') + ')' : '')
  // console.log(userQuery)
  const facetedQuery = '(' + Object.keys(vm.selectedFacets).map(function (key) {
    if (vm.selectedFacets[key].length > 0) {
      return '(' + vm.selectedFacets[key].map(x => [fieldsMap[key], '"' + x.facet + '"'].join(':')).join(' OR ') + ')'
    } else {
      return []
    }
  }).filter(function (array) {
    return array.length > 0
  }).flat().join(' AND ') + ')'
  // console.log(facetedQuery)
  return `${userQuery} ${facetedQuery.length > 2 ? ` ${(userQuery.trim().length > 0 ? 'AND' : '')} ${facetedQuery}` : ''}`
}

// async function fetchNoOfBook2 (vm, sourceKey) {
//   const fieldsMap = fieldsMapping[sourceKey]
//   const source = sources[sourceKey]
//   const hasModel = fieldsMap.has_model
//   // const Book = fieldsMap.book
//   // const Page = fieldsMap.Page
//   let texts = fieldsMap.text.split('|')
//   let problem = false
//   try {
//     let result = await $.ajax({
//       'url': source.url,
//       'cache': true,
//       'traditional': true,
//       'data': {
//         'rows': '0',
//         'wt': 'json',
//         // 'fl': '*,hits:[subquery]',
//         // 'fl': 'id,title_txt_cjk,creator_ss,url_sss,opacUrl_sss,databaseUrl_sss,noOfpages_sss,issued_sss,hits:[subquery]',
//         'fl': 'id',
//         // 'fl': '*,[child parentFilter=hasModel_sss:Book childFilter=' + vm.terms.map(function (term) { return [text, term].join(':') }).join(' AND ') + ']',
//         'q': getQ()
//       },
//       'dataType': 'jsonp',
//       'jsonp': 'json.wrf'
//     })
//     // store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: result.response.numFound})
//   } catch (err) {
//     // store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: 0})
//     problem = true
//   }
// }

async function fetchNoOfBookAndNoOfPage (vm, sourceKey) {
  // let fieldsMap = fieldsMapping[sourceKey]
  let source = sources[sourceKey]
  // let hasModel = fieldsMap.has_model
  // let Book = fieldsMap.book
  // let Page = fieldsMap.Page
  // let text = fieldsMap.text
  // let texts = fieldsMap.text.split('|')
  // console.log(texts)
  // let problem = false
  if (getQ(vm, sourceKey) === ' ') {
      // store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: 0})
      // store.dispatch('collections/updateNoOfPages', {id: sourceKey, noOfPages: 0})
    return
  }
  try {
    let result = await $.ajax({
      'url': source.url,
      'cache': true,
      'traditional': true,
      'data': {
        'rows': '0',
        'wt': 'json',
        // 'fl': '*,hits:[subquery]',
        // 'fl': 'id,title_txt_cjk,creator_ss,url_sss,opacUrl_sss,databaseUrl_sss,noOfpages_sss,issued_sss,hits:[subquery]',
        'fl': 'id',
        // 'fl': '*,[child parentFilter=hasModel_sss:Book childFilter=' + vm.terms.map(function (term) { return [text, term].join(':') }).join(' AND ') + ']',
        'q': getQ(vm, sourceKey),
        'json.facet': '{docCount: "unique(book_id_s)"}'
        // 'fq': getFq(vm, sourceKey)
      },
      'dataType': 'jsonp',
      'jsonp': 'json.wrf'
    })
    if (result.facets) {
      store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: result.facets.docCount || 0})
      store.dispatch('collections/updateNoOfPages', {id: sourceKey, noOfPages: result.facets.count || 0})
      // noOfBook = a.facets.docCount || 0
      // noOfPage = a.facets.count || 0
    } else {
      store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: 0})
      store.dispatch('collections/updateNoOfPages', {id: sourceKey, noOfPages: 0})
    }
    // console.log('fetchNoOfBookAndNoOfPage')
    // console.log(result)
    // return result
    // store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: result.response.numFound})
  } catch (err) {
    store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: 0})
    store.dispatch('collections/updateNoOfPages', {id: sourceKey, noOfPages: 0})
    // console.log(err)
    // store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: 0})
    // problem = true
  }
  store.dispatch('collections/fetchBookIsDone', {always: true})
  // console.log(problem)
  // return {}
}

async function fetchNoOfBook (vm, sourceKey) {
  // let a = await fetchNoOfBookAndNoOfPage(vm, sourceKey)
  // let noOfBook = 0
  // let noOfPage = 0
  // if (a.facets) {
  //   noOfBook = a.facets.docCount || 0
  //   noOfPage = a.facets.count || 0
  // }
  // console.log('fetchNoOfBook')
  let fieldsMap = fieldsMapping[sourceKey]
  let source = sources[sourceKey]
  let hasModel = fieldsMap.has_model
  let Book = fieldsMap.book
  let Page = fieldsMap.Page
  // let text = fieldsMap.text
  let texts = fieldsMap.text.split('|')
  // console.log(texts)
  let problem = false
  try {
    let result = await $.ajax({
      'url': source.url,
      'cache': true,
      'traditional': true,
      'data': {
        'rows': '0',
        'wt': 'json',
        // 'fl': '*,hits:[subquery]',
        // 'fl': 'id,title_txt_cjk,creator_ss,url_sss,opacUrl_sss,databaseUrl_sss,noOfpages_sss,issued_sss,hits:[subquery]',
        'fl': 'id',
        // 'fl': '*,[child parentFilter=hasModel_sss:Book childFilter=' + vm.terms.map(function (term) { return [text, term].join(':') }).join(' AND ') + ']',
        'q': '{!parent which=' + hasModel + ':' + Book + ' score=total}' + (vm.terms.length > 0
          ? texts.map(text => {
            return '(' + vm.terms.map(function (term) { return [term.startsWith('-') ? '-' : '' + text, '' + chineseTranslator.expandTerms(term.startsWith('-') ? term.substring(1) : term) + ''].join(':') }).join(' AND ') + ')'
          }).join(' OR ') : ''),

        'fq': getFq(vm, sourceKey)
      },
      'dataType': 'jsonp',
      'jsonp': 'json.wrf'
    })
    // console.table(['BookCount:', result.response.numFound, noOfBook, result.response.numFound === noOfBook])
    store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: result.response.numFound})
  } catch (err) {
    store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: 0})
    problem = true
  }
  if (!problem) {
    try {
      // console.log(getFq(vm, sourceKey))
      let result = await $.ajax({
        'url': source.url,
        'cache': true,
        'traditional': true,
        'data': {
          'rows': '0',
          'wt': 'json',
          // 'fl': '*,hits:[subquery]',
          // 'fl': 'id,title_txt_cjk,creator_ss,url_sss,opacUrl_sss,databaseUrl_sss,noOfpages_sss,issued_sss,hits:[subquery]',
          'fl': 'id',
          // 'fl': '*,[child parentFilter=hasModel_sss:Book childFilter=' + vm.terms.map(function (term) { return [text, term].join(':') }).join(' AND ') + ']',
          'q': vm.terms.length > 0 ? texts.map(text => {
            return '(' + vm.terms.map(function (term) {
              return [term.startsWith('-') ? '-' : '' + text, '' + chineseTranslator.expandTerms(term.startsWith('-') ? term.substring(1) : term) + ''].join(':')
            }
            ).join(' AND ') + ')'
          }).join(' OR ') : hasModel + ':' + Page,
          'fq': getFq(vm, sourceKey)
        },
        'dataType': 'jsonp',
        'jsonp': 'json.wrf'
      })
      // console.table(['PageCount:', result.response.numFound, noOfPage, result.response.numFound === noOfPage])
      store.dispatch('collections/updateNoOfPages', {id: sourceKey, noOfPages: result.response.numFound})
    } catch (err) {
      store.dispatch('collections/updateNoOfPages', {id: sourceKey, noOfPages: 0})
    }
  }
  store.dispatch('collections/fetchBookIsDone', {always: true})
  // console.log(getQ(vm, sourceKey))
  // console.log({id: sourceKey, noOfBooks: result.response.numFound})
  // return JSON.stringify(result)
  // return source
}

async function fetchBookId (vm, sourceKey, prefetch = true) {
  // console.log('fetchBookId')
  let fieldsMap = fieldsMapping[sourceKey]
  let source = sources[sourceKey]
  // let hasModel = fieldsMap.has_model
  // let Book = fieldsMap.Book
  // let Page = fieldsMap.Page
  // let text = fieldsMap.text
  let bookId = fieldsMap.book_id
  let texts = fieldsMap.text.split('|')
  // let subject = fieldsMap.subject
  // let fq = Object.keys(vm.selectedFacets).map(function (key) {
  //   if (vm.selectedFacets[key].length > 0) {
  //     // console.log('{!terms f=' + fieldsMap[key] + ' separator="，"}' + vm.selectedFacets[key].join('，'))
  //     return '{!terms f=' + fieldsMap[key] + ' separator="，"}' + vm.selectedFacets[key].map(x => x.facet).join('，')
  //   } else {
  //     return ''
  //   }
  // }).filter(function (string) {
  //   return string.length > 0
  // })
  // console.log(fq)
  let job = [sourceKey, vm.$store.getters['collections/getNoOfBooks'](sourceKey), vm.$store.getters['collections/getTotalNoOfBooks'](sourceKey)].join('-')
  try {
    // console.log(getFq(vm, sourceKey))
    let result = await $.ajax({
      'url': source.url,
      'cache': true,
      'traditional': true,
      'data': {
        'rows': '0',
        'wt': 'json',
        // 'fl': '*,hits:[subquery]',
        // 'fl': 'id,title_txt_cjk,creator_ss,url_sss,opacUrl_sss,databaseUrl_sss,noOfpages_sss,issued_sss,hits:[subquery]',
        'fl': 'id',
        // 'fl': '*,[child parentFilter=hasModel_sss:Book childFilter=' + vm.terms.map(function (term) { return [text, term].join(':') }).join(' AND ') + ']',
        'q': texts.map(text => {
          return '(' + vm.terms.map(function (term) {
            return [term.startsWith('-') ? '-' : '' + text, '' + chineseTranslator.expandTerms(term.startsWith('-') ? term.substring(1) : term) + ''].join(':')
          }
        ).join(' AND ') + ')'
        }
        ).join(' OR '),
        'facet': 'on',
        'facet.mincount': '1',
        'facet.limit': prefetch ? '100' : '100',
        'facet.offset': prefetch ? '0' : vm.$store.getters['collections/getNoOfBooks'](sourceKey),
        'facet.field': bookId, // [bookId, subject].join(','),
        'fq': getFq(vm, sourceKey),
        'json.nl': 'arrarr',
        'facet.sort': 'count',
        'facet.threads': '-1'
      },
      'dataType': 'jsonp',
      'jsonp': 'json.wrf'
    })
    // console.log(sourceKey, vm.$store.getters['collections/getNoOfBooks'](sourceKey))
    store.dispatch('collections/addNoOfBooks', {id: sourceKey, noOfBooks: result.facet_counts.facet_fields[fieldsMap.book_id].length})
    store.dispatch('collections/addNoOfPages', {id: sourceKey, noOfPages: result.response.numFound})
    store.dispatch('collections/addBookIds', {id: sourceKey, bookIds: result.facet_counts.facet_fields[fieldsMap.book_id]})
  } catch (err) {
    store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: 0})
    store.dispatch('collections/updateNoOfPages', {id: sourceKey, noOfPages: 0})
    store.dispatch('collections/addBookIds', {id: sourceKey, bookIds: []})
  }
  store.dispatch('collections/removeJob', job)
  if (prefetch) {
    store.dispatch('collections/fetchBookIsDone', {always: true})
  }
}

async function fetchBookId2 (vm, sourceKey, prefetch = true) {
  // console.log('fetchBookId')
  let fieldsMap = fieldsMapping[sourceKey]
  let source = sources[sourceKey]
  let bookId = fieldsMap.book_id
  // let texts = fieldsMap.text.split('|')
  let job = [sourceKey, vm.$store.getters['collections/getNoOfBooks'](sourceKey), vm.$store.getters['collections/getTotalNoOfBooks'](sourceKey)].join('-')
  try {
    // console.log(getFq(vm, sourceKey))
    let result = await $.ajax({
      'url': source.url,
      'cache': true,
      'traditional': true,
      'data': {
        'rows': '0',
        'wt': 'json',
        // 'fl': '*,hits:[subquery]',
        // 'fl': 'id,title_txt_cjk,creator_ss,url_sss,opacUrl_sss,databaseUrl_sss,noOfpages_sss,issued_sss,hits:[subquery]',
        'fl': 'id',
        // 'fl': '*,[child parentFilter=hasModel_sss:Book childFilter=' + vm.terms.map(function (term) { return [text, term].join(':') }).join(' AND ') + ']',
        'q': getQ(vm, sourceKey),
        'facet': 'on',
        'facet.mincount': '1',
        'facet.limit': prefetch ? '100' : '100',
        'facet.offset': prefetch ? '0' : vm.$store.getters['collections/getNoOfBooks'](sourceKey),
        'facet.field': bookId, // [bookId, subject].join(','),
        // 'fq': getFq(vm, sourceKey),
        'json.nl': 'arrarr',
        'facet.sort': 'count',
        'facet.threads': '-1'
      },
      'dataType': 'jsonp',
      'jsonp': 'json.wrf'
    })
    // console.log(sourceKey, vm.$store.getters['collections/getNoOfBooks'](sourceKey))
    store.dispatch('collections/addNoOfBooks', {id: sourceKey, noOfBooks: result.facet_counts.facet_fields[fieldsMap.book_id].length})
    store.dispatch('collections/addNoOfPages', {id: sourceKey, noOfPages: result.response.numFound})
    store.dispatch('collections/addBookIds', {id: sourceKey, bookIds: result.facet_counts.facet_fields[fieldsMap.book_id]})
  } catch (err) {
    store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: 0})
    store.dispatch('collections/updateNoOfPages', {id: sourceKey, noOfPages: 0})
    store.dispatch('collections/addBookIds', {id: sourceKey, bookIds: []})
  }
  store.dispatch('collections/removeJob', job)
  if (prefetch) {
    store.dispatch('collections/fetchBookIsDone', {always: true})
  }
}

async function fetchBooksMetaData (vm, sourceKey, prefetch = true, offset = 100) {
  // console.log(prefetch, sourceKey, offset)
  // console.log(fieldsMapping)……
  let fieldsMap = fieldsMapping[sourceKey]
  // let bookId = fieldsMap.book_id
  let source = sources[sourceKey]
  let texts = fieldsMap.text.split('|')

  if (fieldsMap['json.facet']) {
    console.log(fieldsMap['json.facet'])
  }

  let result = await $.ajax({
    'url': source.url,
    'traditional': true,
    'cache': true,
    'data': {
      'rows': '0',
      'wt': 'json',
      'json.nl': 'arrarr',
      // 'fl': '*,hits:[subquery]',
      // 'fl': 'id,title_txt_cjk,creator_ss,url_sss,opacUrl_sss,databaseUrl_sss,noOfpages_sss,issued_sss,hits:[subquery]',
      // 'fl': 'id,hits:[subquery]',
      // 'hits.fl': fieldsMap.position,
      // 'hits.q': '{!terms f=' + bookId + ' v=$row.id}',
      // 'hits.rows': '0',
      // 'hits.fq': texts.map(text => {
      //   return '(' + vm.terms.map(function (term) { return [term.startsWith('-') ? '-' : '' + text, '' + chineseTranslator.expandTerms(term.startsWith('-') ? term.substring(1) : term) + ''].join(':') }).join(' AND ') + ')'
      // }).join(' OR '),
      // 'fl': '*,[child parentFilter=hasModel_sss:Book childFilter=' + vm.terms.map(function (term) { return [text, term].join(':') }).join(' AND ') + ']',
      'q': '{!parent which=' + fieldsMap.has_model + ':' + fieldsMap.book + ' }' + texts.map(text => {
        return '(' + vm.terms.map(function (term) { return [term.startsWith('-') ? '-' : '' + text, '' + chineseTranslator.expandTerms(term.startsWith('-') ? term.substring(1) : term) + ''].join(':') }).join(' AND ') + ')'
      }).join(' OR '),
      // + `${getFq(vm, sourceKey).length > 0 ? ' AND (' + getFq(vm, sourceKey).join(' AND ') + ')' : ''}`,
      'facet': 'on',
      'facet.mincount': '1',
      'facet.limit': prefetch ? '100' : '1000',
      'facet.offset': prefetch ? '0' : offset,
      'facet.sort': 'count',
      'facet.field': Object.keys(fieldsMap.facets),
      // 'fq': getFq(vm, sourceKey),
      'json.facet': fieldsMap['json.facet'] ? JSON.stringify(fieldsMap['json.facet']) : ''
    },
    'dataType': 'jsonp',
    'jsonp': 'json.wrf'
  })
  // vm.$store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: result.facet_counts.facet_fields.book_id_sss.length})
  // vm.$store.dispatch('collections/updateNoOfPages', {id: sourceKey, noOfPages: result.response.numFound})
  // vm.$store.dispatch('collections/addBookIds', {id: sourceKey, bookIds: result.facet_counts.facet_fields.book_id_sss})
  // console.log({id: sourceKey, noOfBooks: result.response.numFound})

  let finished = true
  if (fieldsMap['json.facet']) {
    console.log(result.facets)
    let facets = Object.keys(result.facets).filter(x => x !== 'count')
    facets.forEach(function (facet) {
      console.log(facet)
      let tempFacet = store.getters['collections/getFacet'](facet) || []
      tempFacet = JSON.parse(JSON.stringify(tempFacet))
      // let tempFacet = vm.facets[fieldsMap.facets[facet]] || {}
      let facetItems = result.facets[facet].buckets
      finished = finished && facetItems.length === 0
      facetItems.forEach((facetItem) => {
        let facet = facetItem.val
        let count = facetItem.count
        let index = tempFacet.findIndex((x) => x.facet === facet)
        if (index === -1) {
          tempFacet.push({facet: facet, count: count})
        } else {
          tempFacet[index].count = tempFacet[index].count + count
        }
      })
      // let _facet = fieldsMap.facets[facet]
      TimSort.sort(tempFacet, CountCompare)
      // console.log(facet, tempFacet)
      store.dispatch('collections/setFacet', { facet: facet, value: tempFacet })
    })
    console.log(facets)
  }
  let facets = Object.keys(result.facet_counts.facet_fields)
  facets.forEach(function (facet) {
    // console.log(facet)
    let tempFacet = store.getters['collections/getFacet'](fieldsMap.facets[facet]) || []
    tempFacet = JSON.parse(JSON.stringify(tempFacet))
    // let tempFacet = vm.facets[fieldsMap.facets[facet]] || {}
    let facetItems = result.facet_counts.facet_fields[facet]
    finished = finished && facetItems.length === 0

    facetItems.forEach((facetItem) => {
      let facet = facetItem[0]
      let count = facetItem[1]
      let index = tempFacet.findIndex((x) => x.facet === facet)
      if (index === -1) {
        tempFacet.push({facet: facet, count: count})
      } else {
        tempFacet[index].count = tempFacet[index].count + count
      }
    })
    // let _facet = fieldsMap.facets[facet]
    TimSort.sort(tempFacet, CountCompare)
    // console.log(facet, tempFacet)
    store.dispatch('collections/setFacet', { facet: (fieldsMap.facets[facet]), value: tempFacet })
  })

  if (!finished && prefetch) {
    setTimeout(fetchBooksMetaData, 500, vm, sourceKey, false, prefetch ? parseInt(offset) : parseInt(offset) + 1000)
  }
  // return result
  // return JSON.stringify(result)
  // return source
}

async function fetchBooksMetaData2 (vm, sourceKey, prefetch = true, offset = 100) {
  // console.log(prefetch, sourceKey, offset)
  // console.log(fieldsMapping)……
  let fieldsMap = fieldsMapping[sourceKey]
  // let bookId = fieldsMap.book_id
  let source = sources[sourceKey]
  // let texts = fieldsMap.text.split('|')
  // if (fieldsMap['json.facet']) {
  //   console.log(fieldsMap['json.facet'], getQ(vm, sourceKey))
  // }
  const jsonFacets = Object.entries(fieldsMap['facets']).reduce((acc, x) => {
    acc[x[1]] = {
      'type': 'terms',
      'field': x[0],
      'limit': prefetch ? 100 : 1000,
      'offset': prefetch ? 0 : offset,
      facet: {
        docCount: 'uniqueBlock(_root_)'
      }
    }
    return acc
  }, {})
  // console.log(JSON.stringify(jsonFacets).replace(/\\"/gm, '').replace(/"/gm, '').replace(/uniqueBlock\(_root_\)/gm, '"uniqueBlock(_root_)"'))

  let result = await $.ajax({
    'url': source.url,
    'traditional': true,
    'cache': true,
    'data': {
      'rows': '0',
      'wt': 'json',
      'json.nl': 'arrarr',
      // 'fl': '*,hits:[subquery]',
      // 'fl': 'id,title_txt_cjk,creator_ss,url_sss,opacUrl_sss,databaseUrl_sss,noOfpages_sss,issued_sss,hits:[subquery]',
      // 'fl': 'id,hits:[subquery]',
      // 'hits.fl': fieldsMap.position,
      // 'hits.q': '{!terms f=' + bookId + ' v=$row.id}',
      // 'hits.rows': '0',
      // 'hits.fq': texts.map(text => {
      //   return '(' + vm.terms.map(function (term) { return [term.startsWith('-') ? '-' : '' + text, '' + chineseTranslator.expandTerms(term.startsWith('-') ? term.substring(1) : term) + ''].join(':') }).join(' AND ') + ')'
      // }).join(' OR '),
      // 'fl': '*,[child parentFilter=hasModel_sss:Book childFilter=' + vm.terms.map(function (term) { return [text, term].join(':') }).join(' AND ') + ']',
      // 'q': '{!parent which=' + fieldsMap.has_model + ':' + fieldsMap.book + ' }' + texts.map(text => {
      //   return '(' + vm.terms.map(function (term) { return [term.startsWith('-') ? '-' : '' + text, '' + chineseTranslator.expandTerms(term.startsWith('-') ? term.substring(1) : term) + ''].join(':') }).join(' AND ') + ')'
      // }).join(' OR '),
      'q': getQ(vm, sourceKey),
      'json.facet': JSON.stringify(jsonFacets).replace(/\\"/gm, '').replace(/"/gm, '').replace(/uniqueBlock\(_root_\)/gm, '"uniqueBlock(_root_)"')
      // + `${getFq(vm, sourceKey).length > 0 ? ' AND (' + getFq(vm, sourceKey).join(' AND ') + ')' : ''}`,
      // 'facet': 'on',
      // 'facet.mincount': '1',
      // 'facet.limit': prefetch ? '100' : '1000',
      // 'facet.offset': prefetch ? '0' : offset,
      // 'facet.sort': 'count',
      // 'facet.field': Object.keys(fieldsMap.facets),
      // 'fq': getFq(vm, sourceKey),
      // 'json.facet': fieldsMap['json.facet'] ? JSON.stringify(Object.entries(fieldsMap['json.facet']).reduce((acc, x) => {
      //   let obj = x[1]
      //   obj.limit = prefetch ? 100 : 1000
      //   obj.offset = prefetch ? 0 : offset
      //   acc[x[0]] = obj
      //   return acc
      // }, {})) : ''
    },
    'dataType': 'jsonp',
    'jsonp': 'json.wrf'
  })
  // vm.$store.dispatch('collections/updateNoOfBooks', {id: sourceKey, noOfBooks: result.facet_counts.facet_fields.book_id_sss.length})
  // vm.$store.dispatch('collections/updateNoOfPages', {id: sourceKey, noOfPages: result.response.numFound})
  // vm.$store.dispatch('collections/addBookIds', {id: sourceKey, bookIds: result.facet_counts.facet_fields.book_id_sss})
  // console.log({id: sourceKey, noOfBooks: result.response.numFound})

  let finished = true
  // if (fieldsMap['json.facet']) {
  // console.log(result.facets)
  const facets = Object.keys(result.facets).filter(x => x !== 'count')
  facets.forEach(function (facet) {
    // console.log(facet)
    let tempFacet = store.getters['collections/getFacet'](facet) || []
    tempFacet = JSON.parse(JSON.stringify(tempFacet))
    // let tempFacet = vm.facets[fieldsMap.facets[facet]] || {}
    let facetItems = JSON.parse(JSON.stringify(result.facets[facet].buckets))
    finished = finished && facetItems.length === 0
    facetItems.forEach((facetItem) => {
      let facet = facetItem.val
      let count = facetItem.docCount
      let index = tempFacet.findIndex((x) => x.facet === facet)
      if (index === -1) {
        tempFacet.push({facet: facet, count: count})
      } else {
        tempFacet[index].count = tempFacet[index].count + count
      }
    })
    // let _facet = fieldsMap.facets[facet]
    TimSort.sort(tempFacet, CountCompare)
    // console.log(facet, tempFacet)
    store.dispatch('collections/setFacet', { facet: facet, value: tempFacet })
  })
    // console.log(facets)
  // }
  // let facets = Object.keys(result.facet_counts.facet_fields)
  // facets.forEach(function (facet) {
  //   // console.log(facet)
  //   let tempFacet = store.getters['collections/getFacet'](fieldsMap.facets[facet]) || []
  //   tempFacet = JSON.parse(JSON.stringify(tempFacet))
  //   // let tempFacet = vm.facets[fieldsMap.facets[facet]] || {}
  //   let facetItems = result.facet_counts.facet_fields[facet]
  //   finished = finished && facetItems.length === 0

  //   facetItems.forEach((facetItem) => {
  //     let facet = facetItem[0]
  //     let count = facetItem[1]
  //     let index = tempFacet.findIndex((x) => x.facet === facet)
  //     if (index === -1) {
  //       tempFacet.push({facet: facet, count: count})
  //     } else {
  //       tempFacet[index].count = tempFacet[index].count + count
  //     }
  //   })
  //   // let _facet = fieldsMap.facets[facet]
  //   // console.log(JSON.stringify(tempFacet))
  //   TimSort.sort(tempFacet, CountCompare)
  //   // console.log(facet, tempFacet)
  //   store.dispatch('collections/setFacet', { facet: (fieldsMap.facets[facet]), value: tempFacet })
  // })

  if (!finished && prefetch) {
    setTimeout(fetchBooksMetaData2, 500, vm, sourceKey, false, prefetch ? parseInt(offset) : parseInt(offset) + 1000)
  }
  // return result
  // return JSON.stringify(result)
  // return source
}

async function fetchBookMetaDataById (vm, sourceKey, bookId) {
  let fieldsMap = fieldsMapping[sourceKey]
  let source = sources[sourceKey]

  let result = await $.ajax({
    'url': source.url,
    'cache': true,
    'traditional': true,
    'data': {
      'rows': '1',
      'wt': 'json',
      // 'csv.header': 'false',
      // 'fl': '*,hits:[subquery]',
      // 'fl': 'id,title_txt_cjk,creator_ss,url_sss,opacUrl_sss,databaseUrl_sss,noOfpages_sss,issued_sss,hits:[subquery]',
      'fl': [`${fieldsMap.title.split('|').map(t => `title:${t}`).join(',')}`, `${fieldsMap.url.split('|').map(t => `url:${t}`).join(',')}`, `noOfpages:${fieldsMap.noOfpages}`, `databaseurl:${fieldsMap.databaseurl}`, `opacurl:${fieldsMap.opacurl}`].join(','),
      // 'fl': '*,[child parentFilter=hasModel_sss:Book childFilter=' + vm.terms.map(function (term) { return [text, term].join(':') }).join(' AND ') + ']',
      'q': `id:${bookId}`
    },
    'dataType': 'jsonp',
    'jsonp': 'json.wrf'
  })

  if (result.response.docs.length > 0) {
    result.response.docs[0].url = Array.isArray(result.response.docs[0].url) ? result.response.docs[0].url.join('') : result.response.docs[0].url
    result.response.docs[0].noOfpages = Array.isArray(result.response.docs[0].noOfpages) ? result.response.docs[0].noOfpages.join('') : result.response.docs[0].noOfpages
    result.response.docs[0].databaseurl = Array.isArray(result.response.docs[0].databaseurl) ? result.response.docs[0].databaseurl.join('') : result.response.docs[0].databaseurl
    result.response.docs[0].opacurl = Array.isArray(result.response.docs[0].opacurl) ? result.response.docs[0].opacurl.join('') : result.response.docs[0].opacurl
  }
  return result
  // return JSON.stringify(result)
  // return source
}

export default {
  fetchNoOfBook: fetchNoOfBookAndNoOfPage,
  _fetchNoOfBook: fetchNoOfBook,
  fetchBookId: fetchBookId2,
  _fetchBookId: fetchBookId,
  fetchBookMetaDataById: fetchBookMetaDataById,
  fetchBooksMetaData: fetchBooksMetaData2,
  _fetchBooksMetaData: fetchBooksMetaData
}



// WEBPACK FOOTER //
// ./src/assets/solrQuery.js